import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  subtext?: string;
  size?: "md" | "lg";
  className?: string;
};
export function CtaButton({
  label,
  id,
  subtext,
  size = "lg",
  className = ""
}: CtaButtonProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-30" data-mp="cjzkfnbbax1c">
      <a id={id} href={CHECKOUT_URL} className={`animate-pulse-ring group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta text-center font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${size === "lg" ? "px-6 py-5 text-lg sm:text-xl" : "px-5 py-4 text-base sm:text-lg"}`} data-id="element-31" data-mp="qjsbjjqr3f9u">
        <span className="leading-tight" data-id="element-32" data-mp="157n5f3ghvpoi">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-33" data-mp="35yhbc9qmti8d" />
      </a>
      {subtext && <p className="mt-3 max-w-md text-center text-sm text-muted" data-id="element-34" data-mp="3ey3zvuy9itk0">{subtext}</p>}
    </div>;
}